export const savanna_version = '2.2.0';

const cache = new Map();

let global_color_classes = new Array(); // eg ['4564']; used by grape extendor fillColor
let global_AutoComplete_Dictionary = [];
let global_AutoComplete_Dictionary_Documents = [];
let global_AutoComplete_Dictionary_Leave_Reason = [];
window.global_language_phrases = {};
let global_notification_badge = {};
let global_user_has_access_feature_list = {};

let global_datavisible_roles_buffer;

export let global_temp_croppie;
let language_loaded = false;
let holidays_loaded = false;

window.global_AutoComplete_Dictionary = global_AutoComplete_Dictionary;
window.global_AutoComplete_Dictionary_Documents = global_AutoComplete_Dictionary_Documents;
window.global_AutoComplete_Dictionary_Leave_Reason = global_AutoComplete_Dictionary_Leave_Reason;
window.global_notification_badge = global_notification_badge;
window.global_user_has_access_feature_list = global_user_has_access_feature_list;

window.global_datavisible_roles_buffer = global_datavisible_roles_buffer;

window.global_temp_croppie = global_temp_croppie;
window.language_loaded = language_loaded;
window.holidays_loaded = holidays_loaded;



window.global_language_phrases = {};

// An array of dates
export let eventDates = []; // this is always the loggend in employees holidays

export function redirectTologin(){
  if(!current_user_id() && !document.URL.includes("grape-ui/new_password", 0)){
    Grape.navigate('/grape-ui/log-in');
  }
}

/* applies custom styles to body */
export function applyDynamicCSS(cssCode) {
  let style = '<style type="text/css"> ' + cssCode + ' </style>"';
  $('head').append(style);
}

export function addColorToGlobal(value) {
  let found = false;

  for (let i = 0; i < global_color_classes.length; i++)
  {
    if (value == global_color_classes[i])
    {
      found = true;
    }
  }

  if (found == false)
  {
    global_color_classes.push(value);
  }
}

export function clearColorToGlobal() {
  global_color_classes = new Array();
}

export function getColorToGlobalPos(value) {
  for (let i = 0; i < global_color_classes.length; i++)
  {
    if (value == global_color_classes[i]) return i;
  }
  return -1;
}

// TODO: Remove when not used in this file anymore
export function get_local_storage_nullable(key, default_value) {
  let val = localStorage.getItem(key);
  if (val === 'null') val = null;

  if (val === null && default_value !== undefined)
    return default_value;
  else
    return val;
}

// TODO: Remove when not used in this file anymore
export function current_user_id() {
  return get_local_storage_nullable('grape_user_id');
}

// TODO: Remove when not used in this file anymore
export function current_employee_id() {
  return get_local_storage_nullable('employee_id');
}

// returns the translated text based on token
export function getTranslation(token) {
  return (global_language_phrases[token] || token);
}

// TODO: Remove when not used in this file anymore
export function showLoader() {
  $('#loader').show();
  $('#grape_wrapper').addClass('blurfilter');
}


export function setSystemNameText(system_name){
  if ( system_name != "" && system_name != "undefined" && system_name != null ){
    $(".navbar-header").append("<div class='system_name'>"+system_name+"</div>");
  }

  //chrome hack to position name better
  if (navigator.appVersion.indexOf("Chrome/") != -1) {
    $(".system_name").css("top","45px");
    $(".nav-company-name").css("top","45px");
  }

}

export function gotoLoggedInEmployeeProfilePage()
{
  Grape.navigate('/employee/view/' + current_employee_id());
}

export function openHelpDialog(helpDialogName)
{
  Grape.dialog.open(helpDialogName, { employee_id: current_employee_id() });
}

export function getDate(date_obj) {
  let now = null;
  if (typeof date_obj === 'undefined')
    now = new Date();
  else
    now = new Date(date_obj);

  let year = now.getFullYear().toString();
  let month = (now.getMonth() + 1).toString();
  let nowDate = now.getDate().toString();
  let date_str = year + '-' + (month[1] ? month : '0' + month[0]) + '-' + (nowDate[1] ? nowDate : '0' + nowDate[0]);

  return date_str;
}

/* This function is to merge two arrays ( with keys ) */
export function merge_two_date_objects(obj1, obj2) {
  let new_obj = new Array();

  for (let k in obj1)
  {
    if (obj1.hasOwnProperty(k))
    {
      new_obj[k] = obj1[k];
    }
  }

  for (let k in obj2)
  {
    if (obj2.hasOwnProperty(k))
    {
      // if the previous object exists on this date...
      if (new_obj[k] != undefined)
      {
        let tmpDate = new Date(k);
        let prevDate = new Date(new_obj[k].date);

        // check if we have clashing dates
        if (prevDate.getTime() == tmpDate.getTime())
        {
          // clash found, manipulate css... and name
          if (obj2[k].type == 'holiday')
          {
            obj2[k].name = obj2[k].holiday_type + ': ' + obj2[k].name;
          } else
          {
            obj2[k].name = obj2[k].name;
          }

          obj2[k].name += ' / ';

          if (new_obj[k].type == 'holiday')
          {
            obj2[k].name += new_obj[k].holiday_type + ': ' + new_obj[k].name;
          } else
          {
            obj2[k].name += new_obj[k].name;
          }

          // obj2[k].name =  obj2[k].holiday_type + ": " +  obj2[k].name + " / " + new_obj[k].holiday_type + ": " + new_obj[k].name;
          obj2[k].css_class = obj2[k].css_class + ' ' + new_obj[k].css_class;
        }
      }

      // console.log(obj2[k]);

      new_obj[k] = obj2[k];
    }
  }

  return new_obj;
}

export function generateCSScolorCombinations(res) {
  let css = '';

  for (let a = 0; a < res.length; a++)
  {
    // set the holiday colors on its own
    css += ' .datepicker table tr td.' + res[a].holiday_css_class_name + ' { \
      background-color: ' + res[a].holiday_hexcolor + ' !important; \
      background-image :none !important; \
      color: #ffffff !important; \
      } ';

    // this css is here to cater for when request dates falls on same day as the holiday
    css += '.datepicker table tr td.request_date.' + res[a].holiday_css_class_name + ' { \
      background: ' + res[a].holiday_hexcolor + ' !important; /* Old browsers */ \
      background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjYWVlNmY1IiBzdG9wLW9wYWNpdHk9IjEiLz4KICAgIDxzdG9wIG9mZnNldD0iNTAlIiBzdG9wLWNvbG9yPSIjYWVlNmY1IiBzdG9wLW9wYWNpdHk9IjEiLz4KICAgIDxzdG9wIG9mZnNldD0iNTAlIiBzdG9wLWNvbG9yPSIjZmZjMDAwIiBzdG9wLW9wYWNpdHk9IjEiLz4KICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI2ZmYzAwMCIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgPC9saW5lYXJHcmFkaWVudD4KICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2dyYWQtdWNnZy1nZW5lcmF0ZWQpIiAvPgo8L3N2Zz4=)  !important; \
      background: -moz-linear-gradient(-45deg,  ' + res[a].holiday_hexcolor + ' 0%, ' + res[a].holiday_hexcolor + ' 50%, rgb(255,192,0) 50%, rgb(255,192,0) 100%) !important; \
      background: -webkit-gradient(linear, left top, right bottom, color-stop(0%,' + res[a].holiday_hexcolor + '), color-stop(50%,' + res[a].holiday_hexcolor + '), color-stop(50%,rgb(255,192,0)), color-stop(100%,rgb(255,192,0))) !important; \
      background: -webkit-linear-gradient(-45deg,  ' + res[a].holiday_hexcolor + ' 0%,' + res[a].holiday_hexcolor + ' 50%,rgb(255,192,0) 50%,rgb(255,192,0) 100%) !important;  \
      background: -o-linear-gradient(-45deg,  ' + res[a].holiday_hexcolor + ' 0%,' + res[a].holiday_hexcolor + ' 50%,rgb(255,192,0) 50%,rgb(255,192,0) 100%) !important;  \
      background: -ms-linear-gradient(-45deg,  ' + res[a].holiday_hexcolor + ' 0%,' + res[a].holiday_hexcolor + ' 50%,rgb(255,192,0) 50%,rgb(255,192,0) 100%) !important; \
      background: linear-gradient(135deg,  ' + res[a].holiday_hexcolor + ' 0%,' + res[a].holiday_hexcolor + ' 50%,rgb(255,192,0) 50%,rgb(255,192,0) 100%) !important;  \
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#aee6f5", endColorstr="#ffc000",GradientType=1 ) !important;  \
    } ';

    // for when a holiday and a leave_type interacts
    for (let b = 0; b < res[a].leave_type_colors.length; b++)
    {
      css += ' .datepicker table tr td.' + res[a].holiday_css_class_name + '.' + res[a].leave_type_colors[b].css_class_name + ' { \
        background: ' + res[a].leave_type_colors[b].hexcolor + ' !important; \
        background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjYWVlNmY1IiBzdG9wLW9wYWNpdHk9IjEiLz4KICAgIDxzdG9wIG9mZnNldD0iNTAlIiBzdG9wLWNvbG9yPSIjYWVlNmY1IiBzdG9wLW9wYWNpdHk9IjEiLz4KICAgIDxzdG9wIG9mZnNldD0iNTAlIiBzdG9wLWNvbG9yPSIjZmZjMDAwIiBzdG9wLW9wYWNpdHk9IjEiLz4KICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI2ZmYzAwMCIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgPC9saW5lYXJHcmFkaWVudD4KICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2dyYWQtdWNnZy1nZW5lcmF0ZWQpIiAvPgo8L3N2Zz4=)  !important; \
        background: -moz-linear-gradient(-45deg,  ' + res[a].leave_type_colors[b].hexcolor + ' 0%, ' + res[a].leave_type_colors[b].hexcolor + ' 50%, ' + res[a].holiday_hexcolor + ' 50%, ' + res[a].holiday_hexcolor + ' 100%) !important; \
        background: -webkit-gradient(linear, left top, right bottom, color-stop(0%,' + res[a].leave_type_colors[b].hexcolor + '), color-stop(50%,' + res[a].leave_type_colors[b].hexcolor + '), color-stop(50%,' + res[a].holiday_hexcolor + '), color-stop(100%,' + res[a].holiday_hexcolor + ')) !important; \
        background: -webkit-linear-gradient(-45deg,  ' + res[a].leave_type_colors[b].hexcolor + ' 0%,' + res[a].leave_type_colors[b].hexcolor + ' 50%,' + res[a].holiday_hexcolor + ' 50%,' + res[a].holiday_hexcolor + ' 100%) !important;  \
        background: -o-linear-gradient(-45deg,  ' + res[a].leave_type_colors[b].hexcolor + ' 0%,' + res[a].leave_type_colors[b].hexcolor + ' 50%,' + res[a].holiday_hexcolor + ' 50%,' + res[a].holiday_hexcolor + ' 100%) !important;  \
        background: -ms-linear-gradient(-45deg,  ' + res[a].leave_type_colors[b].hexcolor + ' 0%,' + res[a].leave_type_colors[b].hexcolor + ' 50%,' + res[a].holiday_hexcolor + ' 50%,' + res[a].holiday_hexcolor + ' 100%) !important; \
        background: linear-gradient(135deg,  ' + res[a].leave_type_colors[b].hexcolor + ' 0%,' + res[a].leave_type_colors[b].hexcolor + ' 50%,' + res[a].holiday_hexcolor + ' 50%,' + res[a].holiday_hexcolor + ' 100%) !important;  \
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#aee6f5", endColorstr="#ffc000",GradientType=1 ) !important;  \
      } ';
    }
  }

  applyDynamicCSS(css);
  css = '';

  // now set the indivual leave type colors ( we use res[0] here because all the leave type colors are in every res[a] element )
  for (let b = 0; b < res[0].leave_type_colors.length; b++)
  {
    css += '.datepicker table tr td.' + res[0].leave_type_colors[b].css_class_name + ' { \
      background-color: ' + res[0].leave_type_colors[b].hexcolor + ' !important; \
      background-image :none !important; \
      color: #ffffff !important; \
      } ';
  }

  applyDynamicCSS(css);
}

export function parseHolidayDates(res) {
  if (res != null)
  {
    for (let a = 0; a < res.length; a++)
    {
      if (!eventDates[getDate(res[a].holiday_date)])
        eventDates[getDate(res[a].holiday_date)] = { 'date': new Date(res[a].holiday_date), 'name': res[a].description, 'css_class': res[a].css_class_name, 'holiday_type': res[a].holiday_type, 'type': 'holiday' };
    }
    holidays_loaded = true;
  }
}

export function setCalendarHighlightDates(date, dates_array) {
  let _d = new Date(date);
  let _d_string = getDate(_d);

  let highlight = dates_array[_d_string];
  if (highlight)
  {
    if (highlight.type == 'holiday')
    {
      return {
        enabled: true,
        classes: highlight.css_class,
        tooltip: `${highlight.holiday_type} :${highlight.name}`
      };
    } else if (highlight.type == 'finalized_leave')
    {
      return {
        enabled: true,
        classes: 'finalized_leave',
        tooltip: 'Finalized Leave : ' + highlight.name
      };
    } else if (highlight.type == 'use_css_class')
    {
      return {
        enabled: true,
        classes: highlight.css_class,
        tooltip: highlight.name
      };
    } else if (highlight.type == 'request_date')
    {
      return {
        enabled: true,
        classes: 'request_date',
        tooltip: highlight.name
      };
    }
  } else
  {
    return {
      enabled: true,
      classes: 'day',
      tooltip: '&nbsp;'
    };
  }
}

export function extractor(query) {
  let result = /([^,]+)$/.exec(query);
  if (result && result[1])
    return result[1].trim();
  return '';
}

/* the jquery_element_selection is an ID or class for examlpe ".myClass" or "#myid" */
export function alignEmployeePhoto(employee_id, jquery_element_selection) {
  if (employee_id == null || employee_id == undefined)
  {
    return;
  }

  let target = $('#employee_photo_' + employee_id);
  if (jquery_element_selection != undefined) target = $(jquery_element_selection).find('#employee_photo_' + employee_id);

  target.hide();

  let photoInterval;
  let timeoutCounter = 0;
  let img = new Image();

  img.onload = function () {
    let imgthis = this;

    // loop until the dom is actually ready with image
    photoInterval = setInterval(function () {
      timeoutCounter++;

      // this was out of scope so had to re-define
      target = $('#employee_photo_' + employee_id);
      if (jquery_element_selection != undefined) target = $(jquery_element_selection).find('#employee_photo_' + employee_id);

      if (target.width() > 0)
      {
        clearInterval(photoInterval);

        if (imgthis.width > imgthis.height)
        {
          // landscape
          target.css('width', 'auto');
          target.css('height', '50px');

          // now position image
          let fat = target.width() - 50;
          target.css('left', (fat * 0.5 * -1) + 'px');  // move left by 50% of whats left
        } else
        {
          // portait
          target.css('width', '50px');
          target.css('height', 'auto');

          // now position image
          let fat = target.height() - 50;
          target.css('top', (fat * 0.3 * -1) + 'px'); // move up by 30% of whats left
        }

        target.show();
      }

      if (timeoutCounter >= 100) clearInterval(photoInterval);
    }, 500);
  };

  img.src = '/download/employee/' + employee_id + '/photo';
};

export function alignEmployeePhotoSize(employee_id, jquery_element_selection, size) {
  if (employee_id == null || employee_id == undefined)
  {
    return;
  }

  let target = $('#employee_photo_' + employee_id);
  if (jquery_element_selection != undefined) target = $(jquery_element_selection).find('#employee_photo_' + employee_id);

  target.hide();

  let photoInterval;
  let timeoutCounter = 0;
  let img = new Image();

  img.onload = function () {
    let imgthis = this;

    // loop until the dom is actually ready with image
    photoInterval = setInterval(function () {
      timeoutCounter++;

      // this was out of scope so had to re-define
      target = $('#employee_photo_' + employee_id);
      if (jquery_element_selection != undefined) target = $(jquery_element_selection).find('#employee_photo_' + employee_id);

      if (target.width() > 0)
      {
        clearInterval(photoInterval);

        if (imgthis.width > imgthis.height)
        {
          // landscape
          target.css('width', 'auto');
          target.css('height', size + 'px');

          // now position image
          let fat = target.width() - size;
          target.css('left', (fat * 0.5 * -1) + 'px');  // move left by 50% of whats left
        } else
        {
          // portait
          target.css('width', size + 'px');
          target.css('height', 'auto');

          // now position image
          let fat = target.height() - size;
          target.css('top', (fat * 0.3 * -1) + 'px'); // move up by 30% of whats left
        }

        target.show();
      }

      if (timeoutCounter >= 100) clearInterval(photoInterval);
    }, 500);
  };

  img.src = '/download/employee/' + employee_id + '/photo';
};


export function translateNavbar() {
  $('nav .language_phrase').each(function (index) {
    $(this).html(getTranslation($(this).attr('token')));
  });
};

// function to show a preview of the image we are about to upload
export function uploadAndShowImage(input, html_id) {
  if (input.files && input.files[0])
  {
    let reader = new FileReader();

    reader.onload = function (e) {
      $('#' + html_id)
        .attr('src', e.target.result);
    };

    reader.readAsDataURL(input.files[0]);
  }
}

export function readURL(input, html_id, rotate_button)
{
  if (input.files && input.files[0])
  {
    let reader = new FileReader();

    reader.onload = (e) => {
      // Destroy the old Croppie instance if it exists
      if (global_temp_croppie)
      {
        global_temp_croppie.destroy();
      }

      // Set the new image source
      $('#' + html_id).attr('src', e.target.result);

      // Create a new Croppie instance with the new image
      const imageElement = document.getElementById(html_id);
      if (imageElement) {
        global_temp_croppie = new Croppie(imageElement, {
          enableExif: true,
          enableOrientation: true,
          enforceBoundary: true,
          viewport: {
            width: 150,
            height: 150,
          },
          boundary: {
            width: 250,
            height: 250,
          },
        });
      } else {
        console.error(`Element with id '${html_id}' not found`);
      }
    };

    reader.readAsDataURL(input.files[0]);
    $('.' + rotate_button).show();
  }
}
// this function SHOULD only be used by the navbar function - dont use it in other places as the array gets destroyed and loaded in runtime, which can cause loading issues
// rather use the promise checkAccessRights to check access on the spot for single features
export function checkAccessRightsUsingAccessArray(featureName) {
  if (global_user_has_access_feature_list[featureName] == true) return true;
  return false;
};

export async function updateNavbarVisibility() {
  console.log('calling updateNavbarVisibility');

  let allowed_features = [];
  let features = await Grape.cache.get('FeatureAccessListLookup')
  for (let f of features)
    if (f.access === true)
      allowed_features.push(f.feature);

  // NOW THAT WE HAVE A FULL LIST ... CONTINUE
  $('.navbar [data-visible-feature]').each(function () {
    let feature = $(this).attr('data-visible-feature');
    let featureList = feature.split(' ');
    let element = $(this).parent();

    if (featureList.filter(x => allowed_features.includes(x)))
      element.show(); // setting visble
    else
      element.hide(); // setting invisible
  });

  // now show or hide the whole menu based on whats visible/invisible inside (for exmaple Employees or General)
  $('.navbar .top_menu_item').each(function () {
    let topmenuitem = $(this);
    let ulmenu = topmenuitem.children('ul.dropdown-menu');

    // loop through each li to see if its visible or not

    let heading_reference;
    ulmenu.children('li').each(function () {
      // sub heading
      if ($(this).hasClass('list_heading') == true)
      {
        heading_reference = $(this);
        heading_reference.hide(); // hide until we find a visible object underneath it
      }

      if ($(this).hasClass('list_heading') == false)
      {
        // show the list_heading if we found a visible object
        if ($(this).css('display') != 'none')
        {
          if (heading_reference)
          {
            heading_reference.show();
          }
        }
      }
    }); // li each end

    // now loop through list a final time to set top menu visibility
    let visible_count = 0;
    ulmenu.children('li').each(function () {
      // topmenu visibility count
      if ($(this).css('display') != 'none')
      {
        visible_count++;
      } else
      {

      }
    }); // li each end
    // based on how many element are visible inside - hide or show the menu
    if (visible_count == 0)
    {
      topmenuitem.hide();
    } else
    {
      topmenuitem.show();
    }
  }); // topmenu item each end
};

// TODO: Check if this is ever used
export function isUserOnOwnProfilePage() {
  let page_URL = String(window.location.hash);

  if (Number(page_URL.indexOf('#/employee/view/')) === 0)
  {
    // we are on a profile page
    let extracted_employee_number = page_URL.slice(16);

    if (get_local_storage_nullable('employee_id') === Number(extracted_employee_number))
    {
      return true;
    } else
    {
      return false;
    }
  }

  return false;
};

export function openDocumentInNewTab(documentLink) {
  console.log(documentLink, 'frame');
  let win = window.open(documentLink, '');
};

export function gotoLinkAndCloseAllDialogs(_href) {
  Grape.navigate(_href);

  // this is not the best way - but there doesnt seem to be a way to reference the dialog nor is there a close function
  $('div[role="dialog"]').each(function () {
    $(this).remove();
  });

  $('.modal-backdrop').each(function () {
    $(this).remove();
  });
};

// const default_language = 'en';
// const supported_languages = [
//  'en', 'afr','zulu','xho','ndb'
// ];

//  function getLanguage() {
//  return (localStorage.getItem('language') || '');
// }

//  function setLanguage(language) {
//  localStorage.setItem('language', language);
// }

//  function set_language(lang) {
//   console.log('inside');
//  if (!lang)
//  {
//    lang = getLanguage() || window.navigator.userLanguage || window.navigator.language || default_language;
//  }
//  else { setLanguage(lang); console.log('setting', lang); }
//  lang.substring(0, 2).toLowerCase();

//  if (supported_languages.indexOf(lang) < 0) lang = default_language;

//  // app.data.language = lang;
//  // app.views.forEach(v => {
//  //  if (v.router.currentRoute && v.router.currentRoute.url)

//  //    v.router.refreshPage();
//  // });
//  // translate_navbar();
// }

export function calc_math_string(expression) {
  try {
    // Ensure the expression only contains safe characters (digits, operators, parentheses)
    if (/^[0-9+\-*/().\s]+$/.test(expression)) {
      return new Function(`return ${expression};`)();
    } else {
      throw new Error('Invalid characters in expression');
    }
  } catch (error) {
    console.error('Error evaluating expression:', error);
    return null;
  }
}


export function parseLeaveRestrictionRule(_string_to_parse, customization_fields) {
  let description = new String(_string_to_parse);
  let non_color_block_description;

  let myfields = customization_fields; // this is an object of rules eg: {"number_of_days_per_subject": {"name": "number of days per subject","type": "integer","value": "3"}}
  let myArray = new Array();

  let count = 0;
  let color_class = 'red';

  // we need to work out the calculations text between <# and #>

  // first find all substring with anything between <# #>
  let regExp = new RegExp('\<#.*?\#>', 'g');
  let substr = description.match(regExp);

  if (substr)
  {
    let substr_original = substr.slice(); // make a copy of the array

    console.log(substr);

    Object.keys(myfields).forEach(function (key) {
      let replaceStr = '{' + key + '}';
      let regExp = new RegExp(replaceStr, 'g');

      // now replace the {} the with values
      for (let a = 0; a < substr.length; a++)
      {
        substr[a] = substr[a].replace(regExp, myfields[key].value);
      }
    });

    // now remove the <# and #>
    for (let a = 0; a < substr.length; a++)
    {
      substr[a] = substr[a].replace(new RegExp('<#', 'g'), '');
      substr[a] = substr[a].replace(new RegExp('#>', 'g'), '');
    }

    // now calculate math
    for (let a = 0; a < substr.length; a++)
    {
      substr[a] = calc_math_string(substr[a]);
    }

    console.log(substr, 'AFTER');
    console.log(substr_original, 'AFTER ORIG');

    // now replace the sections in the description
    for (let a = 0; a < substr_original.length; a++)
    {
      description = description.replace(substr_original[a], substr[a]);
    }
  } // if subtr end

  non_color_block_description = description;

  // NOW PROCEED WITH REPLACING INPUT FIELDS
  Object.keys(myfields).forEach(function (key) {
    count++;

    // build colors
    switch (count)
    {
      case 1: color_class = 'red'; break;
      case 2: color_class = 'darkblue'; break;
      case 3: color_class = 'orange'; break;
      case 4: color_class = 'green'; break;
      case 5: color_class = 'yellow'; break;
      default: color_class = 'red'; break;
    }

    myArray.push(
      {
        field: key,
        name: myfields[key].name,
        value: myfields[key].value,
        color_class: color_class,
        type: String(myfields[key].type).toLowerCase()
      }
    );

    let replaceStr = '{' + key + '}';
    let regExp = new RegExp(replaceStr, 'g');
    description = description.replace(regExp, "<span class='" + color_class + " blocktext'>" + myfields[key].value + '</span>');
    non_color_block_description = non_color_block_description.replace(regExp, myfields[key].value);
  });

  return {
    description: description,
    non_color_block_description: non_color_block_description,
    customization_rules: myArray
  };
}

export function autocomplete(inp, arr) {
  /* the autocomplete function takes two arguments,
  the text field element and an array of possible autocompleted values: */
  var currentFocus;
  /* execute a function when someone writes in the text field: */
  inp.addEventListener('input', function (e) {
    var a; var b; var i; var val = this.value;
    /* close any already open lists of autocompleted values */
    closeAllLists();
    if (!val) { return false; }
    currentFocus = -1;
    /* create a DIV element that will contain the items (values): */
    a = document.createElement('DIV');
    a.setAttribute('id', this.id + 'autocomplete-list');
    a.setAttribute('class', 'autocomplete-items');
    /* append the DIV element as a child of the autocomplete container: */
    this.parentNode.appendChild(a);
    /* for each item in the array... */
    for (i = 0; i < arr.length; i++)
    {
      /* check if the item starts with the same letters as the text field value: */
      if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase())
      {
        /* create a DIV element for each matching element: */
        b = document.createElement('DIV');
        /* make the matching letters bold: */
        b.innerHTML = '<strong>' + arr[i].substr(0, val.length) + '</strong>';
        b.innerHTML += arr[i].substr(val.length);
        /* insert a input field that will hold the current array item's value: */
        b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
        /* execute a function when someone clicks on the item value (DIV element): */
        b.addEventListener('click', function (e) {
          /* insert the value for the autocomplete text field: */
          inp.value = this.getElementsByTagName('input')[0].value;
          /* close the list of autocompleted values,
        (or any other open lists of autocompleted values: */
          closeAllLists();
        });
        a.appendChild(b);
      }
    }
  });
  /* execute a function presses a key on the keyboard: */
  inp.addEventListener('keydown', function (e) {
    var x = document.getElementById(this.id + 'autocomplete-list');
    if (x) x = x.getElementsByTagName('div');
    if (e.keyCode == 40)
    {
      /* If the arrow DOWN key is pressed,
      increase the currentFocus variable: */
      currentFocus++;
      /* and and make the current item more visible: */
      addActive(x);
    } else if (e.keyCode == 38)
    { // up
      /* If the arrow UP key is pressed,
      decrease the currentFocus variable: */
      currentFocus--;
      /* and and make the current item more visible: */
      addActive(x);
    } else if (e.keyCode == 13)
    {
      /* If the ENTER key is pressed, prevent the form from being submitted, */
      e.preventDefault();
      if (currentFocus > -1)
      {
        /* and simulate a click on the "active" item: */
        if (x) x[currentFocus].click();
      }
    }
  });
  function addActive(x) {
    /* a function to classify an item as "active": */
    if (!x) return false;
    /* start by removing the "active" class on all items: */
    removeActive(x);
    if (currentFocus >= x.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = (x.length - 1);
    /* add class "autocomplete-active": */
    x[currentFocus].classList.add('autocomplete-active');
  }
  function removeActive(x) {
    /* a function to remove the "active" class from all autocomplete items: */
    for (var i = 0; i < x.length; i++)
    {
      x[i].classList.remove('autocomplete-active');
    }
  }
  function closeAllLists(elmnt) {
    /* close all autocomplete lists in the document,
    except the one passed as an argument: */
    var x = document.getElementsByClassName('autocomplete-items');
    for (var i = 0; i < x.length; i++)
    {
      if (elmnt != x[i] && elmnt != inp)
      {
        x[i].parentNode.removeChild(x[i]);
      }
    }
  }
}
